<template>
  <b-modal
    id="modal-flag-add"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    title="ADD BULK PICKUP REQUEST"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-row>
        <b-col
          md="12"
        >
          <SetPickupRequest
            :waybill="wayBill"
            :set-errors="setErrors"
            :set-open="setOpen"
            :refresh="refreshParent"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="errors.length > 0"
        class="mt-4"
      >
        <b-col>
          <b-table
            striped
            hover
            responsive
            :items="errors"
            :fields="fields"
          >
            <template #cell(status)="data">
              <b-badge variant="light-danger">
                {{ data ? 'error' : 'success' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCol,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import SetPickupRequest from '@/components/orders/SetPickupRequest.vue'

function initialState() {
  return {
    open: false,
    modalLoading: false,
    loading: false,
    wayBill: null,
    selectedFlag: null,
    action: null,
    errors: [],
    fields: [
      {
        key: 'waybill_number',
        label: 'Waybill Number',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'status',
        label: 'Status',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'error',
        label: 'Error',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
    ],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    SetPickupRequest,
    BModal,
    BCol,
    BRow,
    BOverlay,
    BTable,
    BBadge,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  methods: {
    async openModal(wayBill) {
      Object.assign(this.$data, initialState())
      this.open = true
      this.wayBill = wayBill
      this.refreshParent = this.$parent.onClickRefresh
    },
    setErrors(val) {
      this.errors = val
    },
    setOpen(val) {
      this.open = val
    },
  },
}
</script>
<style lang="scss">
</style>
